module.exports = __webpack_public_path__ + "static/media/facebook.874b7e48.svg";